import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Packages from "@/pages/Packages";
import BookACall from "@/pages/BookACall";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/book-a-call" element={<BookACall />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            {/* Redirect orphaned routes to Home */}
            <Route path="/services" element={<Navigate to="/" replace />} />
            <Route path="/resources" element={<Navigate to="/" replace />} />
            <Route path="/contact" element={<Navigate to="/book-a-call" replace />} />
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/results" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
